import { cssColorValue, desktopBallad, semanticColors, TextLink } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const FooterTextLink = styled(TextLink)`
  && {
    text-decoration: none;
    color: ${cssColorValue(semanticColors.textBase)};
    ${() => desktopBallad}

    &:hover {
      text-decoration: none;
    }

    &:focus {
      color: ${cssColorValue(semanticColors.textBrightAccent)};
    }
  }
`;
